/* al's product.designer-blanket and product.name-blanket js */
$(function() {
  const qs = document.querySelector.bind(document);
  const qsa = document.querySelectorAll.bind(document);
  
  function is_mobile() {
    //https://stackoverflow.com/a/45666491/16442724
    return /Mobi/i.test(window.navigator.userAgent);
  }
  
  if (document.body.classList.contains('template-product-designer-blanket')) {
//     console.log('bind form stuff');
  }
  
  /*
  //parse colors
  Object.keys(design_matrix).forEach(design => {
    let parsed_colors = {};
    design_matrix[design].colors.forEach(color => {
      let split_colors = color.split('-and-');
      parsed_colors[color] = {
        base_color: split_colors[0],
        text_color: split_colors[1]
      };
    });
    design_matrix[design].colors = parsed_colors;
    console.log(design_matrix[design].colors);
  });
  */
  
  const name_char_count = qs('.name-char-count');
  const color_name = qs('.color-name');
  
  const builder_fields = {
      size:		qs('input[name="size"]'),
      name:		qs('input[name="properties\[Name\]"]'),
      color:	qs('input[name="color"]'),
  //     design:	qs('select[name="design"]'),
  };
  
  //size radios
  $('.radio-group input')
  .on('change', function() {
    // let my_radio_group = this.closest('.radio-group');
    if (!('field' in this.closest('.radio-group')?.dataset)) {
      //not a radio groupf for select
      // return;
    } else {
      let my_label = this.closest('label');
      let my_index = [...my_label.parentElement.children].indexOf(my_label);
      let my_field = $(`select[data-option="${this.closest('.radio-group').dataset.field}"]`);
      console.log('my_index', my_index);
      my_field[0].selectedIndex = my_index;
      my_field.trigger('change'); //jquery trigger required due to shopify's skinned selects. native js trigger doesn't update the skinned input
     
  //     console.log('refocus:', name_field_auto_refocus);
  //     if (name_field_auto_refocus) {
      if (!is_mobile()) {
        builder_fields.name.focus({
          preventScroll: true
        });
      }
  //     }
    }
  })
  .on('click', function() {
    $(this).trigger('change');
  });
  
  let name_field_auto_refocus = false;
  let name_field_auto_refocus_timeout;
  
  //name field
  $('input[name="properties\[Name\]"]')
  .on('keydown keyup search', function() {
    let char_count = 15 - this.value.length;
    let char_remaining = '';
    if (char_count == 0) {
      char_remaining = 'none';
    } else if (char_count < 5) {
      char_remaining = 'low';
    }
    name_char_count.dataset.remaining = char_remaining;
    name_char_count.innerHTML = char_count == 15 ? 'Up to 15 characters' : `${char_count} character${char_count == 1 ? '' : 's'} remaining`;
  })
  /*
  .on('focus', function() {
    name_field_auto_refocus = true;
    clearTimeout('name_field_auto_refocus_timeout');
  })
  */
  .on('blur', function() {
    name_field_auto_refocus_timeout = setTimeout(function() {
      name_field_auto_refocus = false;
    }, 600);
  });
  
  builder_fields.name.addEventListener('focus', function() {
//     console.log('focus');
    setTimeout(function() {
      clearTimeout('name_field_auto_refocus_timeout');
      name_field_auto_refocus = true;
    }, 10);
  });
  
  //color field
//   Array.from(qsa('#product-variants-option-1 option')).forEach(el => {
  setTimeout(function() {
    $('select[data-option="option2"] option').each(function() {
//     console.log(el);
  });
  }, 1000);
  
  $('.radio-group[data-field="option2"]').on('mouseenter', 'label', function() {
//     color_name.dataset.previewName = this.dataset.value;
    color_name.innerHTML = this.dataset.value;
    color_name.classList.add('preview');
    $(this).one('mouseleave', function() {
//       delete color_name.dataset.previewName;
      color_name.innerHTML = color_name.dataset.selectedValue;
      color_name.classList.remove('preview');
    });
  });
  
  $('.radio-group[data-field="option2"] input').on('change', function() {
    color_name.dataset.selectedValue = this.value;
    color_name.innerHTML = color_name.dataset.selectedValue;
  });
  
  //parse url params. this enables linking to a specific color from collection page, and editing an item from cart
  let url_params = new URLSearchParams(window.location.search);
  
  let url_param_name = url_params.get('name');
  if (url_param_name != null) { 
    builder_fields.name.value = decodeURI(url_param_name);
    $(builder_fields.name).trigger('search');
  }

  $preview_container = $('.preview-container');
  $canvas_container = $('.canvas-container');
  $preview = $('.preview');
  
  let url_param_font = url_params.get('font');
  if (url_param_font != null) {
    // document.querySelector(`input[name="properties[Font]"][value="${url_param_font}"]`)?.checked = true;

    //set form field
    const font_input = document.querySelector(`input[name="properties[Font]"][value="${url_param_font}"]`);
    if (font_input) font_input.checked = true;

    //set preview
    // $preview[0].classList.add('suspend-animations');
    $preview[0].dataset.font = url_param_font;
    // $preview[0].classList.remove('suspend-animations');
    
    // radioInput && (radioInput.checked = true);

    // builder_fields.name.value = decodeURI(url_param_name);
    // $(builder_fields.name).trigger('search');
  }
  
  let url_param_orientation = url_params.get('orientation');
  if (url_param_orientation != null) {

    //set form field
    const orientation_input = document.querySelector(`input[name="properties[Orientation]"][value="${url_param_orientation}"]`);
    if (orientation_input) orientation_input.checked = true;
                            
    //set preview
    // $preview[0].classList.add('suspend-animations');
    $preview[0].dataset.orientation = url_param_orientation;
    // $preview[0].classList.remove('suspend-animations');
    
    // builder_fields.name.value = decodeURI(url_param_name);
    // $(builder_fields.name).trigger('search');
  }

  setTimeout(function() {
    $preview[0].classList.add('animate-rotation');  
  }, 500);
  
  let url_param_cart_item = url_params.get('cart_item');
  /*
  test one. stopped short because per shopify support forums, not possible to edit a variant once its in the cart.
  must remove the variant, and add another.
  going to try that, then
  if (url_param_cart_item != null) {
    $('#product-form')
    .prop('action', '/cart/change')
    .prepend(`<input name="line" type="hidden" value="${url_param_cart_item}">`);
    setTimeout(function() {
      $('.add-to-cart').val('Update Cart Item');
    }, 1000);
  }
  */
  
  if (url_param_cart_item != null) {
    qs('.add-to-cart-wrap').dataset.customLabel = 'update';
  }
  
  //googling suggests shopify does not support updating a variant of an item that is already in the cart.
  //therefore, on update, first send an ajax request to remove the old line item, then add the updated item as a new line item.
  $('#product-form').submit(function(e) {
    if (url_param_cart_item != null) {
      e.preventDefault();
      $.post(
        window.Shopify.routes.root + 'cart/change.js',
        {
          line: url_param_cart_item,
          quantity: 0
        },
        function(response) {
          url_param_cart_item = null;
          $('#product-form').trigger('submit');
        }
        , 'json'
      );
    }
  });
  
  /*
  the code below needs a timeout, as shopify genetates the size and color selects after page load.
  shopify doing that, might have something to do with it splitting the single "#product-variants" select generated in liquid, into multiple selects
  */
  setTimeout(function() {
    
  }, 500);
  
//   console.log(design_matrix['under-the-sea'].name);
 
  
  //json sluggify colors and product name
  //based on: https://www.geeksforgeeks.org/how-to-convert-a-string-into-kebab-case-using-javascript/
  function json_sluggify(value) {
    return value
    .replace('+', 'and')
    .replace(/[\s_]+/g, '-')
    .toLowerCase();
  }

  const matrix_product_name = json_sluggify(qs('meta[itemprop=name]').content).replace('-designer-blanket', '');
  
  qsa('.radio-group[data-field="option1"] input').forEach(el => {
    el.dataset.matrixKey = json_sluggify(el.value);
  });
  
  
  //parse colors
  /*
  Object.keys(design_matrix).forEach(design => {
    let parsed_colors = {};
    design_matrix[design].colors.forEach(color => {
      let split_colors = color.split('-and-');
      parsed_colors[color] = {
        base_color: split_colors[0],
        text_color: split_colors[1]
      };
    });
    design_matrix[design].colors = parsed_colors;
    console.log(design_matrix[design].colors);
  });
  */
  console.log('hi');
console.log('matrix name', matrix_product_name);
  
  design_matrix[matrix_product_name].colors = {};
  
  qsa('.radio-group[data-field="option2"] label').forEach(el => {
    let matrix_key = json_sluggify(el.dataset.value);
    el.querySelector('input').dataset.matrixKey = matrix_key;
    
    
    //automatically parse colors
    let split_colors = matrix_key.split('-and-');
    design_matrix[matrix_product_name].colors[matrix_key] = {
      base_color: split_colors[0],
      text_color: split_colors[1]
    };
    
    /*
    el.querySelector('.color-primary').style.backgroundColor = color_matrix[design_matrix[matrix_product_name].colors[matrix_key].base_color];
    el.querySelector('.color-secondary').style.backgroundColor = color_matrix[design_matrix[matrix_product_name].colors[matrix_key].text_color];
    */
  });
  
  //animate preview on scroll
  var element = $('.preview'),
  originalY = element.offset().top;

  // Space between element and top of screen (when scrolling)
  var topMargin = 20;

  // Should probably be set in CSS; but here just for emphasis
  element.css('position', 'relative');

  $(window).on('scroll', function(event) {
    var scrollTop = $(window).scrollTop();
    
//     element.css('top', (scrollTop < originalY) ? 0 : (scrollTop - originalY + topMargin));
    
//     element.stop(false, false).animate({
//       top: scrollTop < originalY ? 0 : scrollTop - originalY + topMargin
//     }, 100);
  });
  
  //focus name on page load, without scrolling (newish browsers)
  builder_fields.name.focus({
    preventScroll: true
  });
  
  // cavnas stuff
  const canvas = qs('.preview-pattern');
  const canvas_text = qs('.preview-text');
  
//   const ctx_text = canvas_text.getContext('2d');
  
  if (!canvas.getContext) {
    // canvas-unsupported code here
    alert('Sorry, live blanket preview is not supporter in your web browser.')
  } else {
    //retinize canvas
    /*
    function createHiPPICanvas(w, h) {
    let ratio = window.devicePixelRatio;
    let cv = document.createElement("canvas");
    cv.width = w * ratio;
    cv.height = h * ratio;
    cv.style.width = w + "px";
    cv.style.height = h + "px";
    cv.getContext("2d").scale(ratio, ratio);
    return cv;
}*/
    
    const ratio = window.devicePixelRatio;
//     const ratio_font_pixelate = .705;//.75;
    let ratio_font_pixelate = .74;//.75;
    canvas.width = canvas.offsetWidth * ratio;
    canvas.height = canvas.offsetHeight * ratio;
    
    if (canvas.offsetWidth > 700) {
      ratio_font_pixelate = .74;
    } else if (canvas.offsetWidth > 450) {
      ratio_font_pixelate = 1;
    } else {
      ratio_font_pixelate = 1;
    }
    
    canvas_text.width = canvas_text.offsetWidth * ratio_font_pixelate;
    canvas_text.height = canvas_text.offsetHeight * ratio_font_pixelate;
    //get contexts
    const ctx = canvas.getContext('2d');
    const ctx_text = canvas_text.getContext('2d');
    
    ctx.scale(ratio, ratio);
    ctx_text.scale(ratio_font_pixelate, ratio_font_pixelate);
    
//     ctx_text.mozImageSmoothingEnabled = false; 
//     ctx_text.imageSmoothingEnabled = false; 
    
    ctx.fillStyle = 'rgb(200, 0, 0)';
    // ctx.fillRect(10, 10, 50, 50);

    ctx.fillStyle = 'rgba(0, 0, 200, 0.5)';
    // ctx.fillRect(30, 30, 50, 50);

    // https://stackoverflow.com/a/22849445/16442724

    let cw = canvas.offsetWidth;
    let ch = canvas.offsetHeight;
    
    const selected_preview = {
      design:	matrix_product_name, //'under-the-sea',
      name:		builder_fields.name.value,
      size:		qs('input[name="size"]:checked').dataset.matrixKey,
      color:	qs('input[name="color"]:checked').dataset.matrixKey
    };
    
    if (selected_preview.design == 'classic-two-colour') {
      Object.assign(selected_preview, {
        font: qs('input[name="properties[Font]"]:checked')?.value,
        orientation: qs('input[name="properties[Orientation]"]:checked')?.value
      });
    }
    
    const rendered_preview = {
      design:	selected_preview.design,
      name:		'',
      size:		'',
      color:	''
    };
    
    function refreshPreview() {
      //if selection is unchanged from rendered canvas, quit render
      if (JSON.stringify(selected_preview) === JSON.stringify(rendered_preview)) return;
      
      //re-render
      if (selected_preview.size != rendered_preview.size || selected_preview.color != rendered_preview.color) {
        renderPreview();
      } else {
        drawText();
      }
      
      //cache rendered values
      rendered_preview.name		= selected_preview.name;
      rendered_preview.size		= selected_preview.size,
      rendered_preview.color	= selected_preview.color;
    }  
    //const nocache = Math.random();
    const nocache = 'false';
    
    function renderPreview() {
//        console.log('renderPreview called');
      
      //add clone for smooth color transition
      /*
      let preview_clone =  $preview.clone().addClass('clone');
      preview_clone.appendTo($preview_container);
      let clone_canvas = preview_clone.find('.preview-pattern');
      let clone_canvas_text = preview_clone.find('.preview-text');
      */
      
      
//       let clone_canvas = $(canvas).clone().addClass('clone').appendTo($preview);
//       let clone_canvas_text = $(canvas_text).clone().addClass('clone').appendTo($preview);
      let queue_resize = (selected_preview.size != rendered_preview.size);
      let queue_recolor = (selected_preview.color != rendered_preview.color);
      queue_recolor = true;
      let preview_clone;
      if (queue_recolor) {
        preview_clone =  $canvas_container.clone().addClass('clone');
        preview_clone.prependTo($preview);

        let clone_canvas = preview_clone.find('.preview-pattern');
        let clone_canvas_text = preview_clone.find('.preview-text');


  //       clone_canvas[0].style.width = clone_canvas[0].offsetWidth;
  //       clone_canvas_text[0].style.width = clone_canvas_text[0].offsetWidth;

  //       clone_canvas[0].style.width = `${clone_canvas[0].offsetWidth}px;`;
  //       clone_canvas_text[0].style.width = `${clone_canvas_text[0].offsetWidth}px;`;

        clone_canvas[0].style.width = `${clone_canvas[0].offsetWidth}px`;
        clone_canvas_text[0].style.width = `${clone_canvas_text[0].offsetWidth}px`;

        let clone_ctx = clone_canvas[0].getContext('2d');
        let clone_ctx_text = clone_canvas_text[0].getContext('2d');

        clone_ctx.drawImage(canvas, 0, 0);
        clone_ctx_text.drawImage(canvas_text, 0, 0);
      }
//       $('.preview').clone().addClass('clone').appendTo('.preview-container');
      
      //set canvas size
      let new_w, new_h;
      
      /*
      portrait code -- unfinished, but dean appears to have no portrait designs to start
      if (design_matrix[selected_preview.design].orientation == 'landscape') {
        new_w = size_matrix[selected_preview.size].width * 4;
        new_h = size_matrix[selected_preview.size].height * 4;
      } else {
        new_w = size_matrix[selected_preview.size].height * 4;
        new_h = size_matrix[selected_preview.size].width * 4;
      }
      */
      
      canvas.width = canvas.offsetWidth * ratio;
      canvas.height = canvas.offsetHeight * ratio;
      
      if (canvas.offsetWidth > 700) {
        ratio_font_pixelate = .74;
      } else if (canvas.offsetWidth > 450) {
        ratio_font_pixelate = .912;
      } else {
        ratio_font_pixelate = 1;
      }
      
      canvas_text.width = canvas_text.offsetWidth * ratio_font_pixelate;
      canvas_text.height = canvas_text.offsetHeight * ratio_font_pixelate;
      //get contexts
      const ctx = canvas.getContext('2d');
      const ctx_text = canvas_text.getContext('2d');

      ctx.scale(ratio, ratio);
      ctx_text.scale(ratio_font_pixelate, ratio_font_pixelate);
      
      cw = canvas.offsetWidth;
      ch = canvas.offsetHeight;
      
      new_w = canvas.offsetWidth;
      new_h = canvas.offsetHeight;
      
      
      let pattern_url = `${theme_asset_dir}designer-${selected_preview.design}-pattern-${selected_preview.size}-${selected_preview.color}-sm.png?nocache=${nocache}`;
      if (selected_preview.design == 'classic-two-colour') pattern_url = `${theme_asset_dir}name-blanket-pattern-${selected_preview.size}-${selected_preview.color}-sm.png?nocache=${nocache}`;
      
      // name-blanket-pattern-cot-oatmeal-and-fawn-sm.png

      //load bg image, clear canvas, draw image
      let img = new Image();
      img.crossOrigin = 'anonymous';
      img.src = pattern_url;//"https://dl.dropboxusercontent.com/u/139992952/stackoverflow/house204-1.jpg";
      img.onload = function() {

        //set canvas size
        ctx.clearRect(0, 0, cw, ch); //clear vanvas //works, but flickers
        // ctx.fillRect(0, 0, new_w, new_h); //clear vanvas //works, but flickers
        // ctx.drawImage(img, 0, 0, new_w, new_h); //draw bg image
        // ctx.drawImage(img, (cw - new_w) / 2, (ch - new_h) / 2, new_w, new_h); //draw bg image
        
        ctx.drawImage(img, (cw - new_w) / 2, 0, new_w, new_h); //draw bg image
        
        drawText(); //draw name
        
        if (queue_resize) {
          $preview[0].classList.remove('resizing');
        }
        
        if (queue_recolor) {
          preview_clone.addClass('animate-out').delay(600).queue(function() {
            preview_clone.remove();
          });
        }
        /*
        //remove clone();
        clone_canvas.addClass("animate-out").delay(600).queue(function() {
          clone_canvas.remove();
//           next();
        });
        clone_canvas_text.addClass("animate-out").delay(600).queue(function() {
          clone_canvas_text.remove();
//           next();
        });
        */
        
        /*
        clone_canvas.addClass('remove-me'(200, function() {
          clone_canvas.remove();
        });
        clone_canvas_text.fadeOut(200, function() {
          clone_canvas_text.remove();
        });
        */
      }
      
     
    }
    
    refreshPreview();
    //redraw text again after half a second, in case more web fonts have loaded
    setTimeout(function() {
      drawText();
    }, 500);
    
    
    
    function drawText() {
//       console.log('drawText called');

      // properties[Font]
      // TODO: this has to accept the font changes from fotn selection, AND, get the fonts when a preview is rendered in the cart.
      const previewContainer = document.querySelector('.preview');
      const font = previewContainer.dataset.font ? fontMatrix[previewContainer.dataset.font] : design_matrix[selected_preview.design].font;
      // const font = 'bebasregular';
      
      ctx_text.textAlign = 'center';
//       ctx_text.font = `bold ${design_matrix[selected_preview.design].font_size} ${design_matrix[selected_preview.design].font}`;
      ctx_text.font = `${design_matrix[selected_preview.design].sizes[selected_preview.size].font_size * canvas.offsetWidth / 100}px ${design_matrix[selected_preview.design].font}`;
      
      //legacy font calculation - used for designer blankets, where font size is static
      ctx_text.font = `${design_matrix[selected_preview.design].sizes[selected_preview.size].font_size * canvas.offsetWidth / 100}px ${font}`;
      console.log(`${design_matrix[selected_preview.design].sizes[selected_preview.size].font_size * canvas.offsetWidth / 100}px ${font}`);
      
      let text_x = canvas.offsetWidth * design_matrix[selected_preview.design].sizes[selected_preview.size].text_x / 100;
      let text_y = canvas.offsetHeight * design_matrix[selected_preview.design].sizes[selected_preview.size].text_y / 100;
      
      //dynamic font size calculation for single name blankets
      let selectedFontMatrixParams;
      if (selected_preview.design == 'classic-two-colour') {
        // console.group('Variable Font Stuff');
        // console.log(design_matrix[selected_preview.design].responsive_sizes[selected_preview.size]['horizontal']);
        // console.log(selected_preview);
        
        //calculate best font size
        const selectedFont = selected_preview.font;
        const selectedOrientation = selected_preview.orientation;
        
        // console.log('selected_preview.font', selected_preview.font);
        // console.log('selected_preview.orientation', selected_preview.orientation);
        
        // const possibleFontSizes = design_matrix[selected_preview.design].responsive_sizes[selected_preview.size]['horizontal']['Quinty'];
        selectedFontMatrixParams = design_matrix[selected_preview.design].responsive_sizes[selected_preview.size][selected_preview.orientation][selected_preview.font];
        //const possibleFontSizes = design_matrix[selected_preview.design].responsive_sizes[selected_preview.size][selected_preview.orientation][selected_preview.font].font_size;
        const possibleFontSizes = selectedFontMatrixParams.font_size;

        const inputLength = selected_preview.name.length;
        let selectedFontSize = null;
        
        for (const key in possibleFontSizes) {
          if (key >= inputLength) {
            selectedFontSize = possibleFontSizes[key];
            break;
          }
        }
        if (selectedFontSize === null) selectedFontSize = possibleFontSizes[15];
        
        // console.log(selectedFontSize);
        // console.groupEnd();
        
        // ctx_text.font = `${design_matrix[selected_preview.design].sizes[selected_preview.size].font_size * canvas.offsetWidth / 100}px ${font}`;
        ctx_text.font = `${selectedFontSize * canvas.offsetWidth / 100}px ${font}`;

        
        // ctx_text.letterSpacing = '-0.05rem';
        ctx_text.letterSpacing = selectedFontMatrixParams.letterSpacing;
        
        // console.log('selectedFontMatrixParams', selectedFontMatrixParams);
        text_x = canvas.offsetWidth * selectedFontMatrixParams.text_x / 100;
        text_y = canvas.offsetHeight * selectedFontMatrixParams.text_y / 100;
      }
      
//       console.log('text size', text_x, text_y); //this is correct. so why doesnt this line work?
      
//       text_x = 0;
//       text_y = 0;
      
      ctx_text.clearRect(0, 0, canvas_text.offsetWidth, canvas_text.offsetHeight); //clear vanvas //works, but flickers
      
      if ('stroke_color' in design_matrix[selected_preview.design].colors[selected_preview.color]) {
        ctx_text.strokeStyle = design_matrix[selected_preview.design].colors[selected_preview.color].stroke_color;
        ctx_text.lineWidth = design_matrix[selected_preview.design].colors[selected_preview.color].stroke_width;
        ctx_text.strokeText(name, text_x, text_y);
      }

      //text color
      if (design_matrix[selected_preview.design].darker_text_variants.includes(selected_preview.color)) {
        ctx_text.fillStyle = color_matrix_text_darker[design_matrix[selected_preview.design].colors[selected_preview.color].text_color];
      } else {
        ctx_text.fillStyle = color_matrix_text[design_matrix[selected_preview.design].colors[selected_preview.color].text_color];
      }
//       ctx_text.font = `bold 30px Arial`;
      
//       console.log(design_matrix[selected_preview.design].colors[selected_preview.color].text_color);
      // ctx_text.textBaseline = 'middle';
      ctx_text.textBaseline = (selected_preview.design == 'classic-two-colour') ? 'middle' : 'alphabetic';
      
      ctx_text.fillText(selected_preview.name, text_x, text_y);
      // ctx_text.strokeText(selected_preview.name, text_x, text_y);
      
      let thicknessFactor = 0;
      let thickenFactorX = selectedFontMatrixParams?.thickenFactorX ?? 0;
      let thickenFactorY = selectedFontMatrixParams?.thickenFactorY ?? 0;
      
      let offsetStep = 0.1;
      
      // for (let dx = -thickenFactorX; dx <= thickenFactorX; dx += step) {
      //   for (let dy = -thickenFactorY; dy <= thickenFactorY; dy += step) {
      //     ctx_text.fillText(selected_preview.name, text_x + dx, text_y + dy);
      //   }
      // }

      // Draw the text with an outline in all directions
      //start with the provided offset in a negative value, and re-draw it by the step size, until we reach its positive value
      for (let offsetX = -thickenFactorX; offsetX <= thickenFactorX; offsetX += offsetStep) {
          for (let offsetY = -thickenFactorY; offsetY <= thickenFactorY; offsetY += offsetStep) {
              ctx_text.fillText(selected_preview.name, text_x + offsetX, text_y + offsetY);
          }
      }

      /*
      for (var i = 0; i < 5; i++) {
        // ctx_text.fillText(selected_preview.name, text_x, text_y);
        // ctx_text.fillText(selected_preview.name, text_x, text_y);
        
        ctx_text.fillText(selected_preview.name, text_x + i * thicknessFactor, text_y + i * thicknessFactor);
        ctx_text.fillText(selected_preview.name, text_x + i * thickenFactorX, text_y + i * thickenFactorY);
      }
      */
/*
      name_char_count.innerHTML = 15 - builder_fields.name.value.length;
      let selected_color = qs('input[name="color"]:checked').value;
      // let selected_design = qs('input[name="design"]').options[ qs('input[name="design"]').selectedIndex].value;
      // let field_design = qs('select[name="design"]');
      // console.log(field_design);
      let selected_design = builder_fields.design.options[builder_fields.design.selectedIndex].value;
      // select.options[select.selectedIndex].value
      let selected_size = qs('input[name="size"]:checked').value;

      // let name = qs('[name="name"]').value;
      let name = builder_fields.name.value;
      ctx_text.textAlign = 'center';
      // ctx.font = '48px serif';
      ctx_text.font = `bold ${design_matrix[selected_design].font_size} ${design_matrix[selected_design].font}`;
      // ctx.fillStyle = 'orange';
      // ctx.fillText('Hello world', 10, 50);
      let text_x = canvas.width * design_matrix[selected_design].sizes[selected_size].text_x / 100;
      let text_y = canvas.height * design_matrix[selected_design].sizes[selected_size].text_y / 100;
      // let text_y = 50;

      //clear canvas
      ctx_text.clearRect(0, 0, canvas_text.width, canvas_text.height); //clear vanvas //works, but flickers

      //maybe use stroke
      if ('stroke_color' in design_matrix[selected_design].colors[selected_color]) {
        ctx_text.strokeStyle = design_matrix[selected_design].colors[selected_color].stroke_color;
        ctx_text.lineWidth = design_matrix[selected_design].colors[selected_color].stroke_width;
        ctx_text.strokeText(name, text_x, text_y);
      }

      //text color
      ctx_text.fillStyle = design_matrix[selected_design].colors[selected_color].text_color;

      ctx_text.fillText(name, text_x, text_y);
      */
    }
    
    $(builder_fields.name).on('keydown keyup search', function(e) {
      if (event.key == 'Enter') event.preventDefault(); //prevent form submission on return
      selected_preview.name = this.value;
      refreshPreview();
    });
    
    $('.radio-group[data-field="option1"] input').on('change', function() {
      selected_preview.size = this.dataset.matrixKey;
      $preview[0].dataset.size = this.value;
//       $preview[0].classList.add('resizing');
      setTimeout(function() {
      	refreshPreview();
      }, 450);
    });

    $('.radio-group.product-font input').on('input', function() {
      console.log(this.value);
      document.querySelector('.preview').dataset.font = this.value;
      selected_preview.font = this.value;
      
      //todo: re-render font (probably with a nice animation; but maybe sans animation)
      canvas_text.classList.add('changing');
      setTimeout(function() {
      	// refreshPreview();
      }, 450);
      drawText();
      document.querySelector('input[name="properties[Name]"]').focus();
    });
    
    $('.radio-group.product-orientation input').on('input', function() {
      // selected_preview.orientation = this.dataset.matrixKey;
      $preview[0].dataset.orientation = this.value;
      selected_preview.orientation = this.value;
      $('.preview-container').addClass('show-orientation-tip');
      $(this).closest('.option-group').addClass('show-orientation-tip');
      
      // on playtesting, at a pinch, without min-maxing interpolation effects, redrawing the text exactly mid-flip (anim time / 2),
      // makes the transition look nice-enough and mostly hidden from the eye.
      // redrawing text either at beginning or end of animation, catches the eye and looks jerky and jarring.
      setTimeout(function() {
        drawText();
      	// refreshPreview();
      }, 250 / 2);
      
      // $preview[0].classList.add('resizing');
      // setTimeout(function() {
      // 	refreshPreview();
      // }, 450);
    });
    
    $('.radio-group[data-field="option2"] input').on('change', function() {
      selected_preview.color = this.dataset.matrixKey;
      refreshPreview();
    });
  }
});